import { useMemo, useState } from 'react';
import Helmet from '../lib/Helmet';
import { RATES, GST_RATE, EXCHANGE, KIT_COPPER_METRES } from '../data/pricing';
import { usedSources } from '../data/guideInverter';
import {
  INSTALL_SEO, INSTALL_UPDATED, INSTALL_SOURCES, EXAMPLE, TOOL_COPPER, installContent, withGst, bill, toolText,
} from '../data/guideInstall';
import { GuideHeader, GuideBody, ToolCard, Choice, Rich } from '../components/guide/GuideParts';
import InstallBill from '../components/guide/InstallBill';

// Route: /blog/ac-installation-cost — AC guide 6 (20 Oct 2026), written to
// GUIDES_PLAYBOOK.md section 3. Every word comes from installContent() in
// data/guideInstall.js, and every rupee from RATES in data/pricing.js, which
// scripts/guide-pages.js reads too.

function CostTool({ r, tool }) {
  const [copperM, setCopper] = useState(5);
  const [stand, setStand] = useState(true);
  const [old, setOld] = useState('none');
  return (
    <ToolCard title={tool.title}>
      <Choice label="Copper pipe" value={copperM} onChange={setCopper} options={TOOL_COPPER.map((m) => ({ value: m, label: `${m} metres` }))} />
      <Choice label="Stand for the outdoor unit" value={stand} onChange={setStand} options={[{ value: true, label: 'Yes' }, { value: false, label: 'No' }]} />
      <Choice label="Your old AC" value={old} onChange={setOld}
        options={[{ value: 'none', label: 'None' }, { value: 'remove', label: 'Remove it' }, { value: 'exchange', label: 'Exchange it' }]} />
      <p className="rounded-xl bg-gray-50 p-3.5 text-[17px] leading-snug text-gray-900" aria-live="polite"><Rich text={toolText(r, copperM, stand, old)} /></p>
    </ToolCard>
  );
}

export default function InstallGuide() {
  const { c, r, ex, S } = useMemo(() => {
    const content = installContent(RATES, GST_RATE, EXCHANGE, KIT_COPPER_METRES);
    const rates = withGst(RATES, GST_RATE);
    return { c: content, r: rates, ex: bill(rates, EXAMPLE), S: usedSources(INSTALL_SOURCES, content) };
  }, []);

  return (
    <>
      <Helmet>
        <title>{INSTALL_SEO.title}</title>
        <meta name="description" content={INSTALL_SEO.meta} />
        <meta property="og:title" content={INSTALL_SEO.title} />
        <meta property="og:description" content={INSTALL_SEO.meta} />
      </Helmet>
      <main className="bg-white pb-16 pt-16 lg:pt-20">
        <article className="mx-auto max-w-[760px] px-4 text-base leading-relaxed text-gray-900">
          <GuideHeader seo={INSTALL_SEO} updated={INSTALL_UPDATED} crumb={INSTALL_SEO.crumb} />
          <GuideBody c={c} sources={S} current="ac-installation-cost" ctaSource="guide_install"
            ctaTitle="Want an exact quote for your home?"
            watch={<InstallBill lines={ex.lines} copperM={EXAMPLE.copperM} watch={c.watch} sources={S} />}
            tool={<CostTool r={r} tool={c.tool} />} />
        </article>
      </main>
    </>
  );
}
